import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, unref as _unref, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-dae6d628"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/img/logos/Logo_Thunnissen.jpg",
  width: "140",
  alt: "Logo van Thunnissen"
}, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Account activeren", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Om uw account te activeren of uw wachtwoord te resetten vult u hieronder uw e-mailadres en persoonlijke activatiecode in. Vervolgens kunt u een nieuw wachtwoord kiezen.", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "E-mailadres", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Persoonlijke activatiecode", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Nieuw wachtwoord", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Nieuw wachtwoord bevestigen", -1))

import { authStore } from '@/stores/auth'
import { computed, onMounted, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import PasswordRule from '@/components/account/PasswordRule.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'ActivatePassword',
  setup(__props) {

const route = useRoute()
const router = useRouter()
const resetPassword = ref<{ email:string|null, activationKey:string|null, password:string|null, passwordConfirmation:string|null }>({
  email: null,
  activationKey: null,
  password: null,
  passwordConfirmation: null
})

const minRequiredFields = computed(() => {
  const validEmail = !!(resetPassword.value.email && /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(resetPassword.value.email))
  return !!(validEmail && resetPassword.value.activationKey && resetPassword.value.password && resetPassword.value.passwordConfirmation && resetPassword.value.password === resetPassword.value.passwordConfirmation)
})

const contains = computed(() => {
  const hasLowercase = /[a-z]/
  const hasUppercase = /[A-Z]/
  const hasNumber = /\d/
  const hasSpecialChars = /[ `!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~]/

  return {
    lowercase: resetPassword.value.password ? hasLowercase.test(resetPassword.value.password) : false,
    uppercase: resetPassword.value.password ? hasUppercase.test(resetPassword.value.password) : false,
    number: resetPassword.value.password ? hasNumber.test(resetPassword.value.password) : false,
    specialChar: resetPassword.value.password ? hasSpecialChars.test(resetPassword.value.password) : false,
    eightChars: resetPassword.value.password ? resetPassword.value.password.length >= 8 : false
  }
})

const passwordStrongEnough = computed(() => {
  return contains.value.lowercase && contains.value.uppercase && contains.value.number && contains.value.specialChar && contains.value.eightChars
})

onMounted(() => {
  resetPassword.value.email = typeof route.query.email === 'string' ? route.query.email : null
  resetPassword.value.activationKey = typeof route.query.activationKey === 'string' ? route.query.activationKey : null
})

return (_ctx: any,_cache: any) => {
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_input_password = _resolveComponent("a-input-password")!
  const _component_a_button = _resolveComponent("a-button")!

  return (_openBlock(), _createBlock(_component_a_row, { style: {"height":"100vh","margin":"0"} }, {
    default: _withCtx(() => [
      _createVNode(_component_a_col, {
        xs: 24,
        md: 12,
        xl: 16,
        class: "login-image"
      }),
      _createVNode(_component_a_col, {
        xs: 24,
        md: 12,
        xl: 8,
        style: {"padding":"64px 16px"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_row, { style: {"margin-bottom":"64px"} }, {
            default: _withCtx(() => [
              _createVNode(_component_a_col, {
                span: 20,
                offset: 2
              }, {
                default: _withCtx(() => [
                  _hoisted_1
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_a_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_a_col, {
                span: 20,
                offset: 2
              }, {
                default: _withCtx(() => [
                  _hoisted_2,
                  _hoisted_3,
                  _createVNode(_component_a_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_col, { span: 24 }, {
                        default: _withCtx(() => [
                          _hoisted_4,
                          _createVNode(_component_a_input, {
                            type: "email",
                            name: "email",
                            value: resetPassword.value.email,
                            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((resetPassword.value.email) = $event))
                          }, null, 8, ["value"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_col, { span: 24 }, {
                        default: _withCtx(() => [
                          _hoisted_5,
                          _createVNode(_component_a_input, {
                            type: "text",
                            name: "activation_key",
                            value: resetPassword.value.activationKey,
                            "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((resetPassword.value.activationKey) = $event))
                          }, null, 8, ["value"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_col, { span: 24 }, {
                        default: _withCtx(() => [
                          _hoisted_6,
                          _createVNode(_component_a_input_password, {
                            name: "password",
                            value: resetPassword.value.password,
                            "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((resetPassword.value.password) = $event))
                          }, null, 8, ["value"]),
                          _createVNode(_component_a_row, {
                            class: "no-mb",
                            style: {"margin-top":"16px"}
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_col, { span: 24 }, {
                                default: _withCtx(() => [
                                  _createVNode(PasswordRule, {
                                    label: "Bevat minimaal 8 tekens.",
                                    valid: _unref(contains).eightChars
                                  }, null, 8, ["valid"]),
                                  _createVNode(PasswordRule, {
                                    label: "Bevat een kleine letter.",
                                    valid: _unref(contains).lowercase
                                  }, null, 8, ["valid"]),
                                  _createVNode(PasswordRule, {
                                    label: "Bevat een hoofdletter.",
                                    valid: _unref(contains).uppercase
                                  }, null, 8, ["valid"]),
                                  _createVNode(PasswordRule, {
                                    label: "Bevat een nummer.",
                                    valid: _unref(contains).number
                                  }, null, 8, ["valid"]),
                                  _createVNode(PasswordRule, {
                                    label: "Bevat een speciaal teken. Bijv. (!@#$%&*)",
                                    valid: _unref(contains).specialChar
                                  }, null, 8, ["valid"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_col, { span: 24 }, {
                        default: _withCtx(() => [
                          _hoisted_7,
                          _createVNode(_component_a_input_password, {
                            name: "password_confirm",
                            value: resetPassword.value.passwordConfirmation,
                            "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((resetPassword.value.passwordConfirmation) = $event))
                          }, null, 8, ["value"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_col, { span: 24 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_button, {
                            type: "primary",
                            class: "fw-btn",
                            style: {"margin-bottom":"16px"},
                            loading: _unref(authStore)().loading,
                            disabled: !_unref(minRequiredFields) || !_unref(passwordStrongEnough) || _unref(authStore)().loading,
                            onClick: _cache[4] || (_cache[4] = ($event: any) => (_unref(authStore)().resetPassword(resetPassword.value)))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Account activeren")
                            ]),
                            _: 1
                          }, 8, ["loading", "disabled"]),
                          _createVNode(_component_a_button, {
                            type: "link",
                            class: "fw-btn",
                            onClick: _cache[5] || (_cache[5] = ($event: any) => (_unref(router).push({ name: 'Login' })))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Terug naar inloggen")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})